module.exports = __webpack_public_path__ + "media/images/icons/justify-right-087699ede1827fc1ee405e2bf020f8e4.svg";